import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const RepoSettingsPermissionsLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./permissions'),
});
